import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { showResult } from '../utils';

import type { DoNotCallRestrictionType } from 'infrastructure/enums';

const url = 'reports/reports/normal-readings';

export type TSendNormalReadingsReportProps = {
  startDate?: number;
  endDate?: number;
  interactionStatus?: boolean;
  clinicGuid?: string;
  doNotCallRestrictionType?: DoNotCallRestrictionType;
  doctorLoginGuid?: string;
  agencyDoctorLoginGuid?: string;
  lastInteractionSort?: 'asc' | 'desc';
};

const sendNormalReadingsReportFn = async (
  props: TSendNormalReadingsReportProps,
) => {
  const { data, error } = await dataService.createOne<{ response: string }>(
    url,
    props,
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useSendNormalReadingsReport = () => {
  const { mutate, isLoading, error } = useMutation<
    { response: string } | undefined,
    string | undefined,
    TSendNormalReadingsReportProps
  >({
    mutationKey: ['sendNormalReadingsReport'],
    mutationFn: sendNormalReadingsReportFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { sendReportToEmail: mutate, isLoading };
};
